// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Userlot-inventory.css */
.lot-inventory-parent-container {
  display:block;
}

.lot-inventory-container {
  width: 1200px;
  margin: 50px auto;
  margin-top:100px;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
}

.lot-inventory-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.lot-inventory-header img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin-right: 20px;
}

.lot-inventory-header input[type="file"] {
  display: none;
}

.lot-inventory-header .change-photo-label {
  cursor: pointer;
  color: #007bff;
  text-decoration: underline;
}

.lot-inventory-form {
  display: flex;
  flex-wrap: wrap;
}

.lot-inventory-form label {
  flex: 1 1 45%;
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
}

.lot-inventory-form label:nth-child(odd) {
  margin-right: 5%;
}

.lot-inventory-form label span {
  margin-bottom: 5px;
  font-weight: bold;
}

.lot-inventory-form input,
.lot-inventory-form select {
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
}

.lot-inventory-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.lot-inventory-actions button {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-left: 10px;
}

.lot-inventory-actions button[type="button"] {
  background-color: #ccc;
}

.lot-inventory-actions button[type="submit"] {
  background-color: #4caf50;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/components/LotInventoryTable.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb","sourcesContent":["/* src/components/Userlot-inventory.css */\n.lot-inventory-parent-container {\n  display:block;\n}\n\n.lot-inventory-container {\n  width: 1200px;\n  margin: 50px auto;\n  margin-top:100px;\n  padding: 20px;\n  background-color: #ffffff;\n  border-radius: 10px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n}\n\n.lot-inventory-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.lot-inventory-header img {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  margin-right: 20px;\n}\n\n.lot-inventory-header input[type=\"file\"] {\n  display: none;\n}\n\n.lot-inventory-header .change-photo-label {\n  cursor: pointer;\n  color: #007bff;\n  text-decoration: underline;\n}\n\n.lot-inventory-form {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.lot-inventory-form label {\n  flex: 1 1 45%;\n  margin-bottom: 15px;\n  display: flex;\n  flex-direction: column;\n}\n\n.lot-inventory-form label:nth-child(odd) {\n  margin-right: 5%;\n}\n\n.lot-inventory-form label span {\n  margin-bottom: 5px;\n  font-weight: bold;\n}\n\n.lot-inventory-form input,\n.lot-inventory-form select {\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n}\n\n.lot-inventory-actions {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n.lot-inventory-actions button {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-left: 10px;\n}\n\n.lot-inventory-actions button[type=\"button\"] {\n  background-color: #ccc;\n}\n\n.lot-inventory-actions button[type=\"submit\"] {\n  background-color: #4caf50;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
